import Vue from 'vue'
import Storage from './Storage'
import Helper from './Helper'

export default {
  getCountries () {
    return Vue.http.get('data/countries')
  },
  getOffers (countryId) {
    return Vue.http.get(`data/offers?country_id=${countryId}`)
  },
  getWebmastersNoGrid (countryId) {
    return Vue.http.get(`data/external-webmasters?country_id=${countryId}`)
  },
  getGoods (countryId) {
    return Vue.http.get(`data/goods?country_id=${countryId}`)
  },
  postChooseMainGood (country, product) {
    return Vue.http.post(`statistic/operator-cross-sell/choose-main-good?country_id=${country}`, product)
  },
  postCancelMainGood (country, product) {
    return Vue.http.post(`statistic/operator-cross-sell/cancel-main-good?country_id=${country}`, product)
  },
  getCrossSell () {
    return Vue.http.get(`statistic/operator-cross-sell?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&operator_id=${Helper.getOperatorsList()}&${Helper.getDateRange()}`)
  },
  getGoodsMain () {
    return Vue.http.get(`data/goods/goods-with-id?country_id=${Helper.getCountryList()}`)
  },
  getWebmasters (countryId) {
    return Vue.http.get(`data/webmasters?country_id=${countryId}`)
  },
  getWebmastersAll (countryId) {
    return Vue.http.get(`data/webmasters/get-all?country_id=${countryId}`)
  },
  getWebmastersGraphs (webmaster) {
    return Vue.http.get(`statistic/webmasters/graph?country_id=${Helper.getCountryList()}&by_wm=${webmaster}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getSourcesGraps (sources) {
    return Vue.http.get(`statistic/webmasters/source-graph?country_id=${Helper.getCountryList()}&source=${sources}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}&external_wm=${Helper.getWebsTags()}`)
  },
  getGrid () {
    return Vue.http.get(`statistic/webmasters/cpa?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}&manual=&by_wm=${Helper.getWebsList()}`)
  },
  getArrivalNewLeads (isParse) {
    return Vue.http.get(`statistic/order-forecasting?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}&manual=&by_wm=${Helper.getWebsList()}&roll_up_level=${isParse}`)
  },
  getOperators (countryId, offerId = '') {
    return Vue.http.get(`data/operators?country_id=${countryId}&offer_id=${offerId}`)
  },
  getCurrencyHistory (currency) {
    if (currency instanceof Array) {
      let setParams = arr => arr.map(x => `currency[]=${x}`).join('&')
      return Vue.http.get(`data/currency-history?${setParams(currency)}${Helper.getDateRange()}`)
    } else {
      return Vue.http.get(`data/currency-history?currency=${currency}&${Helper.getDateRange()}`)
    }
  },
  getDashboardStatistic () {
    return Vue.http.get('statistic/dash')
  },
  getLastUpdateTime () {
    return Vue.http.get('data/last-update')
  },
  getOfferRentabilityСhangeStatistic (offerId, vat, out, packaging) {
    return Vue.http.get(`statistic/offer-rentability/change-expenses?country_id=${Storage.selectedCountry.id}&offer_id=${offerId}&vat=${vat}&out=${out}&packaging=${packaging}`)
  },
  getOfferRentabilityСhangeStatisticVAT (offerId, vat) {
    return Vue.http.get(`statistic/offer-rentability/change-expenses?country_id=${Storage.selectedCountry.id}&offer_id=${offerId}&vat=${vat}`)
  },
  getOfferRentabilityСhangeStatisticOUT (offerId, out) {
    return Vue.http.get(`statistic/offer-rentability/change-expenses?country_id=${Storage.selectedCountry.id}&offer_id=${offerId}&out=${out}`)
  },
  getOfferRentabilityСhangeStatisticPACK (offerId, packaging) {
    return Vue.http.get(`statistic/offer-rentability/change-expenses?country_id=${Storage.selectedCountry.id}&offer_id=${offerId}&packaging=${packaging}`)
  },
  getOfferRentabilityAverage () {
    return Vue.http.get(`statistic/offer-rentability/averages?by_wm=${Helper.getWebsList()}&country_id=${Storage.selectedCountry.id}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getOfferRentabilityCountryStatistic () {
    return Vue.http.get(`statistic/offer-rentability/country-expenses?country_id=${Storage.selectedCountry.id}&${Helper.getDateRange()}`)
  },
  getOfferRentabilityStatistic () {
    return Vue.http.get(`statistic/offer-rentability?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList(false)}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getRentabilityExpenseExpection () {
    return Vue.http.get(`statistic/expense-expection?country_id=${Helper.getCountryList()}&${Helper.getMonthRange()}&by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}`)
  },
  postRentabilityExpenseExpection (obj) {
    return Vue.http.post(`statistic/expense-expection/change-call-center-expenses?country_id=${Storage.selectedCountry.id}`, obj)
  },
  postEditOfferRentability (post) {
    return Vue.http.post(`statistic/offer-rentability/change-expenses?country_id=${Storage.selectedCountry.id}`, {
      ...post
    })
  },
  getConversionsCountryStatistic () {
    return Vue.http.get(`statistic/conversions/country?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getConversionsCouriersStatistic () {
    return Vue.http.get(`statistic/conversions/couriers?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&${Helper.getDateRange()}`)
  },
  getConversionsOffersStatistic () {
    return Vue.http.get(`statistic/conversions/offers?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getConversionsPeriodStatistic () {
    return Vue.http.get(`statistic/conversions/period?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getConversionsBuyoutStatistic () {
    return Vue.http.get(`statistic/conversions/quantity?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getConversionsFlypost () {
    return Vue.http.get(`statistic/conversions/flypost?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  postConversionsFlypost (obj) {
    return Vue.http.post(`statistic/conversions/change-delivery-cost?country_id=${Storage.selectedCountry.id}`, obj)
  },
  getWebmasterStatistic () {
    return Vue.http.get(`statistic/webmasters?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getWebmasterSourceStatistic () {
    return Vue.http.get(`statistic/webmasters/source?by_wm=${Helper.getWebsList()}&webmaster_id=${Helper.getWebmasterId()}&country_id=${Helper.getCountryList(false)}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}&external_wm=${Helper.getWebsTags()}`)
  },
  getWebmasterLandStatistic () {
    return Vue.http.get(`statistic/webmasters/landing?by_wm=${Helper.getWebsList()}&webmaster_id=${Helper.getWebmasterId()}&country_id=${Helper.getCountryList(false)}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}&external_wm=${Helper.getWebsTags()}`)
  },
  getLandGraps (sources) {
    return Vue.http.get(`statistic/webmasters/landing-graph?country_id=${Storage.selectedCountry.id}&source=${sources}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}&external_wm=${Helper.getWebsTags()}`)
  },
  getWebmasterPayments () {
    return Vue.http.get(`statistic/webmasters-payments?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getWebmasterPaymentChange (wmid, fixto, fixfrom) {
    return Vue.http.get(`statistic/webmasters-fixes/change-fix?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&wm_id=${wmid}&fix_to=${fixto}&fix_from=${fixfrom}`)
  },
  getWebmasterPaymentHistory () {
    return Vue.http.get(`statistic/webmasters-fixes?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}`)
  },
  getReturnReasonStatistic () {
    return Vue.http.get(`statistic/return-reason?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getOperatorStatistic () {
    return Vue.http.get(`statistic/operator-statistic?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&operator_id=${Helper.getOperatorsList()}&${Helper.getDateRange()}`)
  },
  getOperatorActivity () {
    return Vue.http.get(`statistic/operator-queries?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&operator_id=${Helper.getOperatorsList()}&${Helper.getDateRange()}`)
  },
  getOperatorOrder () {
    return Vue.http.get(`statistic/order-processing?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&operator_id=${Helper.getOperatorsList()}&${Helper.getDateRange()}`)
  },
  getOperatorConversion () {
    return Vue.http.get(`statistic/operators-summary?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&operator_id=${Helper.getOperatorsList()}&${Helper.getDateRange()}`)
  },
  getCouriers () {
    return Vue.http.get('data/couriers')
  },
  getRefundsStatistic (reasonType) {
    return Vue.http.get(`statistic/return-reason?by_wm=${Helper.getWebsList()}&reason_type_id=${reasonType}&country_id=${Storage.selectedCountry.id}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&${Helper.getDateRange()}`)
  },
  getRefundsCancelOperators () {
    return Vue.http.get(`statistic/operator-cancels?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&manual=${Storage.byManualFilter}&${Helper.getDateRange()}`)
  },
  getReasons () {
    return Vue.http.get(`statistic/return-reason/reason-types?country_id=${1534}&${Helper.getDateRange()}`)
  },
  getReturnReasonStatisticByMonth (reasonType) {
    return Vue.http.get(`statistic/return-reason/summary-by-month?by_wm=${Helper.getWebsList()}&webmaster_id=${Helper.getWebmasterId()}&reason_type_id=${reasonType}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&${Helper.getDateRange()}`)
  },
  getReturnReasonStatisticByDay (reasonType, date) {
    return Vue.http.get(`statistic/return-reason/summary-by-month?by_wm=${Helper.getWebsTags()}&reason_type_id=${reasonType}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&date_from=${date}&date_to=${date}`)
  },
  getBuyoutStatistic () {
    return Vue.http.get(`statistic/buyout-statistic?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&${Helper.getDateRange()}`)
  },
  getBuyoutStatisticByWeeks () {
    return Vue.http.get(`statistic/buyout-statistic/by-weeks?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&${Helper.getDateRange()}`)
  },
  getBuyoutStatisticByDays () {
    return Vue.http.get(`statistic/buyout-statistic/by-days?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&${Helper.getDateRange()}`)
  },
  getBuyoutStatisticMonth () {
    return Vue.http.get(`statistic/buyout-statistic/by-months?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&courier_id=${Helper.getCouriersList()}&${Helper.getDateRange()}`)
  },
  getRemnantsOrdersReceipt () {
    return Vue.http.get(`statistic/remnants-orders-receipt/get-orders-receipt?country_id=${Helper.getCountryList()}&${Helper.getDateCreatedRange()}&${Helper.getDateReceiptRange()}`, {
    })
  },
  getRemnantsBalance () {
    return Vue.http.get(`statistic/remnants-orders-receipt/remnants-balance?country_id=-1${Helper.getDateRangeFrom()}`)
  },
  postRemnantsBalance (obj) {
    return Vue.http.post(`statistic/remnants-orders-receipt/change-product-price?country_id=-1`, obj)
  },
  getProductTags () {
    return Vue.http.get(`statistic/remnants-orders-receipt/offer-tags?country_id=1547`)
  },
  getRemnantsCountry () {
    return Vue.http.get(`statistic/remnants-orders-receipt/loads?country_id=${Helper.getCountryList()}${Helper.getDateRange()}`)
  },
  getRemnantsCountryById () {
    return Vue.http.get(`data/goods/goods-with-id?country_id=${Helper.getCountryList()}`)
  },
  getRemnandsChanges () {
    return Vue.http.get(`statistic/remnants-orders-receipt/remnants-changes?country_id=${Helper.getCountryList()}`)
  },
  getRemnands () {
    return Vue.http.get(`statistic/remnants-orders-receipt/get-remnants?country_id=${Helper.getCountryList()}`)
  },
  getGraphConversion () {
    return Vue.http.get(`statistic/conversion-graphic?by_wm=${Helper.getWebsListNew()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getMonthRange()}`)
  },
  putEditOrder (obj) {
    return Vue.http.post(`statistic/remnants-orders-receipt/edit-order?country_id=${Storage.selectedCountry.id}&id=${obj.id}`, {
      [obj.title]: obj.value
    })
  },
  putEditRemains (obj) {
    return Vue.http.post(`statistic/remnants-orders-receipt/change-remains?country_id=${Storage.selectedCountry.id}`, {
      country_id: Storage.selectedCountry.id,
      product_id: obj.id,
      [obj.title]: obj.value
    })
  },
  deleteOrder (offerid) {
    return Vue.http.get(`statistic/remnants-orders-receipt/delete-order?country_id=${Storage.selectedCountry.id}&id=${offerid}`)
  },
  postEditOrder (offerid, obj) {
    return Vue.http.post(`statistic/remnants-orders-receipt/edit-order?country_id=${Storage.selectedCountry.id}&id=${offerid}`, obj)
  },
  postRemnandsNew (formData) {
    return Vue.http.post(`statistic/remnants-orders-receipt/new-order?country_id=${Storage.selectedCountry.id}`, formData)
  },
  profileChangePassword (oldPassword, newPassword, newPasswordRepeat) {
    return Vue.http.post('user/update-password', {
      old_password: oldPassword,
      password: newPassword,
      password_repeat: newPasswordRepeat
    })
  },
  profileUpdate (email, firstName, lastName) {
    return Vue.http.post('user/update-profile', {
      email: email,
      first_name: firstName,
      last_name: lastName
    })
  },
  profileChangeLanguage (lang) {
    return Vue.http.post('user/update-lang', {
      lang: lang
    })
  },
  disabledDasbourdCountry (id) {
    return Vue.http.post('statistic/dash/disable-country', {
      country_id: id
    })
  },
  enabledDashboardCountry (id) {
    return Vue.http.post('statistic/dash/turn-on-country', {
      country_id: id
    })
  },
  saveOperatorStatisticExportHistory (systemBonus, paidBonus, bonusType) {
    return Vue.http.post(`statistic/operator-statistic/save-export-history/?country_id=${Storage.selectedCountry.id}`, {
      system_bonus: systemBonus,
      paid_bonus: paidBonus,
      bonus_type: bonusType,
      date_from: Storage.selectedDateFrom,
      date_to: Storage.selectedDateTo,
      offer_id: Helper.getOffersList()
    })
  },
  getOperatorStatisticExportHistory () {
    return Vue.http.get(`statistic/operator-statistic/export-history/?country_id=${Storage.selectedCountry.id}`)
  },
  getOperatorApprovedDuringDay () {
    return Vue.http.get(`statistic/offer-activity?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}`)
  },
  getChengeLog (type, page, perpage) {
    return Vue.http.get(`data/change-log?type=${type}&page=${page}&per_page=${perpage}&sort_id=1`)
  },
  getLastVersion () {
    return Vue.http.get('data/last-version')
  },
  getChangeVersion (page, perpage) {
    return Vue.http.get(`data/versions?page=${page}&per_page=${perpage}&sort_id=1`)
  },
  getWebAnalysis () {
    return Vue.http.get(`statistic/webmasters/analysis?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&by_wm=${Helper.getWebsList()}&${Helper.getDateRangeAnalytics()}&${Helper.getDateRangeAnalyticsSecond()}`)
  },
  getDisabledCountry () {
    return Vue.http.get('statistic/dash/get-disabled-countries')
  },
  getAveragesGraphic (id) {
    return Vue.http.get(`statistic/dash/averages-graphic?country_id=${id}`)
  },
  getAveragesGraphicAllCountry () {
    return Vue.http.get(`statistic/dash/averages-graphic?country_id=${-1}`)
  },
  getBranch (filial, indexCourier, month) {
    return Vue.http.get(`statistic/conversions/cities-flypost?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Storage.selectedCountry.id}&offer_id=${indexCourier}&${Helper.getDataRangeSearch(month)}&filial=${filial}`)
  },
  getBranchSum (filial, month) {
    return Vue.http.get(`statistic/conversions/cities-flypost?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Storage.selectedCountry.id}&${Helper.getDataRangeSearch2(month)}&filial=${filial}`)
  },
  getRingingSms () {
    return Vue.http.get(`statistic/sms-robocall-statistic?by_wm=${Helper.getWebsListNew()}&country_id=${Storage.selectedCountry.id}&offer_id=${Helper.getOffersList()}&${Helper.getDateRange()}&courier_id=${Helper.getCouriersList()}`)
  },
  getRingingRates () {
    return Vue.http.get(`statistic/sms-robocall-statistic/get-costs?country_id=${Helper.getCountryList()}`)
  },
  postRingingRates (rate) {
    return Vue.http.post(`statistic/sms-robocall-statistic/change-costs?country_id=${Helper.getCountryList()}`, rate)
  },
  getTemplateSms () {
    return Vue.http.get(`data/sms-template?country_id=${Helper.getCountryList()}`)
  },
  getSentSmsTemplate () {
    return Vue.http.get(`statistic/sms-template?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}${Helper.getDateRange()}&operator_id=${Helper.getOperatorsList()}`)
  },
  getWebPopup (wm) {
    return Vue.http.get(`data/webmaster-countries?by_wm=${wm}&${Helper.getDateRange()}`)
  },
  getCallStatistics (isWorkShift) {
    return Vue.http.get(`statistic/calls?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}${Helper.getDateRange()}&is_work_shift=${isWorkShift}`)
  },
  getOperatorsAnalysis () {
    return Vue.http.get(`statistic/operator-analysis/analysis?country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}&by_wm=${Helper.getWebsListNew()}&${Helper.getDateRangeAnalytics()}&${Helper.getDateRangeAnalyticsSecond()}`)
  },
  getWorkTimingKC () {
    return Vue.http.get(`statistic/call-center-timings?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}${Helper.getDateRange()}`)
  },
  getCallStatisticsHourly () {
    return Vue.http.get(`statistic/calls/work-shift?by_wm=${Helper.getWebsList()}&manual=${Storage.byManualFilter}&country_id=${Storage.selectedCountry.id}&offer_id=${Helper.getOffersList()}${Helper.getDateRange()}`)
  },
  webmasterStatus (wmId, countryId, offerId, status) {
    return Vue.http.post(`data/webmaster-status/assign?webmaster_id=${wmId}&country_id=${countryId}&offer_id=${offerId}&status=${status}`)
  },
  historyWebmasterStatus () {
    return Vue.http.get(`data/webmaster-status/history?&country_id=${Storage.selectedCountry.id || Storage.selectedCountry[0].id}&offer_id=${Helper.getOffersList()}`)
  },
  getRingingHolds () {
    return Vue.http.get(`statistic/hold-calls?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}${Helper.getDateRange()}`)
  },
  getNewOrders () {
    return Vue.http.get(`statistic/new-orders-statistic?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}${Helper.getDateRange()}&operator_id=${Helper.getOperatorsList()}`)
  },
  getNewOrdersWeek () {
    return Vue.http.get(`statistic/new-orders-statistic/weekly?by_wm=${Helper.getWebsList()}&country_id=${Helper.getCountryList()}&offer_id=${Helper.getOffersList()}${Helper.getDateRange()}&operator_id=${Helper.getOperatorsList()}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/API.js